import { render, staticRenderFns } from "./FormGetQuote.vue?vue&type=template&id=495b98ce&scoped=true"
import script from "./FormGetQuote.vue?vue&type=script&lang=js"
export * from "./FormGetQuote.vue?vue&type=script&lang=js"
import style0 from "./FormGetQuote.vue?vue&type=style&index=0&id=495b98ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b98ce",
  null
  
)

export default component.exports